exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#panorama[data-v-ce82cdfe]{position:absolute}", ""]);

// exports
